export class LocalsModel {
    public cd_local: string = '';
    public ds_local: string = '';
    public selected: boolean = false;
  }
  
  export class LocalsList {
    public items: LocalsModel[] = [];
  }
  
  export class OPsModel {
    public branchCode: string = '';
    public cycleCode: string = '';
    public orderCode: string = '';
  }
  
  export class OPsList {
    public items: OPsModel[] = [];
  }
  
  export class ProductsOpModel {
    public cd_empresa: string = '';
    public nr_ciclo: string = '';
    public nr_op: string = '';
    public cd_produto: string = '';
    public cd_seqgrupo: string = '';
    public cd_nivel: string = '';
    public ds_nivel: string = '';
    public ds_produto: string = '';
    public cd_cor: string = '';
    public ds_cor: string = '';
    public ds_tamanho: string = '';
    public cd_local: string = '';
    public qt_op: number = 0;
    public qt_selected: number = 0;
  }
  
  export class ProductsOpList {
    public items: ProductsOpModel[] = [];
  }
  
  export class ProductsGroupedModel {
    public cd_nivel: string = '';
    public ds_nivel: string = '';
    public qtSelected: number = 0;
    public colors: ProductsColorModel[] = [];
  }
  
  export class ProductsGroupedList {
    public items: ProductsGroupedModel[] = [];
  }
  
  export class ProductsColorModel {
    public cd_cor: string = '';
    public ds_cor: string = '';
    public qtSelected: number = 0;
    public size: ProductsOpModel[] = [];
  }
  
  export class ProductsColorList {
    public items: ProductsColorModel[] = [];
  }
  
  export class ProductSelectionMovModal {
    public indexProduct: number = 0;
    public indexColor: number = 0;
    public indexSize: number = 0;
    public description: string = '';
    public qtOp: number = 0;
    public qtSelected: number = 0;
  }
  
  export class MovtoOPMessageTomas {
    public TP_HISTORICOMOV: string = '51';
    public CD_COMPONENTE: string = '';
    public IN_NAOSEQLOCAL: string = 'T';
    public IN_VALIDALOGLIMITE: string = 'T';
    public DS_LSTMOVIMENTO: ProductMovToOpMsgTomas[] = [];
  }
  
  export class ProductMovToOpMsgTomas {
    public CD_PRODUTO: string = '';
    public QT_PRODUTO: string = '';
    public CD_EMPRESA: string = '';
    public NR_CICLO: string = '';
    public NR_OP: string = '';
    public CD_SEQGRUPO: string = '';
    public CD_LOCALORIGEM: string = '';
    public NR_SEQPROGORIGEM: string = '';
    public CD_LOCALDESTINO: string = '';
    public NR_SEQPROGDESTINO: string = '';
    public NR_ORDEMORIGEM: string = '';
    public NR_ORDEMDESTINO: string = '';
  }
  
  export class ProductMovToOpMsgTomasList {
    public items: ProductMovToOpMsgTomas[] = [];
  }
  
  export class GetOPsRequest {
    public cdEmpresa: string = '';
    public cdLocal: string = '';
    public nrOp: string = '';
    public dsNivel: string = '';
  }
  
  export class GetItemsOPRequest {
    public cdEmpresa: string = '';
    public cdLocal: string = '';
    public nrCiclo: string = '';
    public nrOp: string = '';
    public cdSeqgrupo: string = '';
  }
  
 export class ProductMovToOpMsgTomass {
    constructor(
      public CD_EMPRESA: string,
      public NR_CICLO: string,
      public NR_OP: string,      
      public CD_LOCALORIGEM: string,
      public CD_LOCALDESTINO: string,      
      public CD_PRODUTO: number,
      public QT_PRODUTO: number
    ) {}
  }